import {all, call, put, takeLatest, select} from 'redux-saga/effects';
import {logout} from '../actions/action_auth';
import * as surveyActions from '../actions/action_survey';
import * as actions from '../actions/action_survey_trackers';
import * as constants from '../constants';
import * as api from '../services/api';

function* loadTrackers({payload}) {
    try {
        const response = yield call(
            api.fetchSurveyTrackers,
            payload.surveyId,
            payload.waveId,
            payload.offset,
            payload.limit,
            payload.sortBy,
            payload.filter,
            payload.filterText,
        );
        yield put(actions.surveyTrackersSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyTrackersFailure(error));
    }
}

function* sendTrackers({payload}) {
    try {
        const response = yield call(
            api.sendTrackedUsersMessages,
            payload.surveyId,
            payload.waveId,
            payload.data,
        );
        yield put(actions.surveyTrackersSendSuccess(response.data));
        yield put(surveyActions.requestSurvey(payload.surveyId));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyTrackersSendFailure(error));
    }
}

function* deleteTracker({payload}) {
    try {
        const response = yield call(
            api.deleteSurveyTracker,
            payload.surveyId,
            payload.waveId,
            payload.trackerId,
        );
        yield put(actions.surveyTrackerDeleteSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyTrackerDeleteFailure(error));
    }
}

function* deleteTrackers({payload}) {
    try {
        const response = yield call(
            api.deleteSurveyTrackers,
            payload.surveyId,
            payload.waveId,
        );
        yield put(actions.surveyTrackersDeleteSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyTrackersDeleteFailure(error));
    }
}

function* saveTracker({payload}) {
    try {
        const response = yield call(
            api.saveSurveyTracker,
            payload.surveyId,
            payload.waveId,
            payload.data,
        );
        yield put(actions.surveyTrackersSaveSuccess(response.data));
        yield put(surveyActions.requestSurvey(payload.surveyId));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyTrackersSaveFailure(error));
    }
}

function* testTracker({payload}) {
    try {
        const response = yield call(
            api.testSurveyTracker,
            payload.surveyId,
            payload.waveId,
            payload.data,
        );
        yield put(actions.surveyTrackersTestSuccess(response.data));
        yield put(surveyActions.requestSurvey(payload.surveyId));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyTrackersTestFailure(error));
    }
}

function* updateAllSurveysTrackersArchive({payload}) {
    try {
        const response = yield call(
            api.updateAllSurveysTrackersArchive,
            {
                id: payload.id,
                trackerArchiveFrequency: payload.trackerArchiveFrequency,
                trackerArchiveFrequencyValue: payload.trackerArchiveFrequencyValue,
            },
        );
        yield put(actions.surveyTrackersArchiveUpdateSuccess(response.data));
        // If a survey is currently loaded in the UI, refresh it so forms reflect updated values
        try {
            const currentSurvey = yield select((state) => state.survey && state.survey.item);
            if (currentSurvey && currentSurvey.id) {
                yield put(surveyActions.requestSurvey(currentSurvey.id));
            }
        } catch (err) {
            // non-blocking: ignore select/refresh errors
        }
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.surveyTrackersArchiveUpdateFailure(error));
    }
}

export default function* root() {
    yield all([
        takeLatest(constants.SURVEY_TRACKERS_REQUESTED, loadTrackers),
        takeLatest(constants.SURVEY_TRACKERS_SEND_REQUESTED, sendTrackers),
        takeLatest(constants.SURVEY_TRACKERS_DELETE_REQUESTED, deleteTracker),
        takeLatest(constants.SURVEY_WAVE_TRACKERS_DELETE_REQUESTED, deleteTrackers),
        takeLatest(constants.SURVEY_TRACKERS_SAVE_REQUESTED, saveTracker),
        takeLatest(constants.SURVEY_TRACKERS_TEST_REQUESTED, testTracker),
        takeLatest(constants.SURVEY_TRACKERS_ARCHIVE_UPDATE_REQUESTED, updateAllSurveysTrackersArchive),
    ]);
}
